import React, { Component } from "react";
import "./map.page.sass";
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import Footer from "../../layouts/footer/footer.component";
import DrawerNav from "../../components/drawer/drawer.component";
import NavBar from "../../layouts/navbar/navbar.component";
import * as L from "leaflet";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectLatlng, selectNearest } from "../../redux/site/site.selector";
import Pin from "../../assets/icon/pngegg.png";
import AgenciesPin from "../../assets/icon/pngfind.com-pin-png-524884.png";
import { withRouter } from "react-router-dom";
import qs from "query-string";
import { SetLatLng, SetNearest } from "../../redux/site/site.actions";
import Axios from "axios";
import { Setting } from "../../setting";

class MapPage extends Component {
	componentDidMount() {
		const { latLang, Nearest, history, setNearest } = this.props;

		const SetData = (coord, Near) => {
			const firstmap = L.tileLayer(
				"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
				{
					maxZoom: 19,
					attribution:
						'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				}
			);

			let myPin = L.icon({
				iconUrl: Pin,
				iconSize: [28, 45],
				iconAnchor: [14, 45],
				popupAnchor: [0, -45],
			});

			let agenciesPin = L.icon({
				iconUrl: AgenciesPin,
				iconSize: [30, 50],
				iconAnchor: [15, 50],
				popupAnchor: [0, -45],
			});

			let map = L.map("mapsearch", {
				center: coord,
				tap: false,
				zoom: 12,
				maxZoom: 22,
				layers: [firstmap],
			});

			let layerGroup = L.layerGroup();

			let bounds = [coord];

			Near.map((item) => {
				//address: "بلوار معلم"
				// city: "مشهد"
				// code: "5106"
				// id: 11
				// lat: "36.333554"
				// lng: "59.512639"
				// phone: "05132722522"
				//full_name

				/** CALCULATE DISTANCE */ /** CALCULATE DISTANCE */ /** CALCULATE DISTANCE */
				/** CALCULATE DISTANCE */

				function getDistance(origin, destination) {
					// return distance in meters
					let lon1 = toRadian(origin[1]),
						lat1 = toRadian(origin[0]),
						lon2 = toRadian(destination[1]),
						lat2 = toRadian(destination[0]);

					let deltaLat = lat2 - lat1;
					let deltaLon = lon2 - lon1;

					let a =
						Math.pow(Math.sin(deltaLat / 2), 2) +
						Math.cos(lat1) *
							Math.cos(lat2) *
							Math.pow(Math.sin(deltaLon / 2), 2);
					let c = 2 * Math.asin(Math.sqrt(a));
					let EARTH_RADIUS = 6371;
					const distance = c * EARTH_RADIUS * 1000;
					return Math.round(distance / 1000);
				}

				function toRadian(degree) {
					return (degree * Math.PI) / 180;
				}

				// END CALCULATE DISTANCE
				L.marker([item.lat, item.lng], {
					icon: agenciesPin,
				})
					.bindPopup(
						`
                <div class="map-popup">
                    <h6>نام نماینده : ${item.full_name}</h6><hr/>
                    <span>شماره تلفن نمایندگی : <a href="tel:${item.phone}">${
							item.phone
						}</a></span><br/>
                    <span>کد نمایندگی : ${item.code}</span><br/>
                    <span>فاصله تا نمایندگی : ${getDistance(coord, [
											item.lat,
											item.lng,
										])} km</span><br/>
                    <span>آدرس : ${item.address}</span><br/>
                    <div class="direction-div">
                        <a target="_blank" rel="noreferrer" href="https://www.google.com/maps/dir/${
													coord[0]
												},%20${coord[1]}/${item.lat},%20${
							item.lng
						}">مسیریابی</a>
                    </div>
                </div>
            `
					)
					.addTo(layerGroup);
				bounds.push([item.lat, item.lng]);
			});

			const querylat = qs.parse(window.location.search).lat;
			const querylng = qs.parse(window.location.search).lng;

			let mylocation =
				querylat && querylng
					? L.marker(coord, {
							icon: myPin,
					  }).addTo(layerGroup).bindPopup(`
                <div class="map-popup">
                    <h6>موقعیت نمایندگی</h6><hr />
                    <span>طول جغرافیایی : ${coord[0].toFixed(5)}</span><br/>
                    <span>عرض جغرافیایی : ${coord[1].toFixed(5)}</span>
                </div>
            `)
					: L.marker(coord, {
							icon: myPin,
					  }).addTo(layerGroup).bindPopup(`
											<div class="map-popup">
													<h6>مکان فعلی من</h6><hr />
													<span>طول جغرافیایی : ${coord[0].toFixed(5)}</span><br/>
													<span>عرض جغرافیایی : ${coord[1].toFixed(5)}</span>
											</div>
									`);
			layerGroup.addTo(map);
			map.fitBounds(bounds);
			mylocation.openPopup();
		};

		if (latLang && Nearest) {
			SetData(latLang, Nearest);
		} else {
			let lat = parseFloat(qs.parse(history.location.search).lat);
			let lng = parseFloat(qs.parse(history.location.search).lng);
			let cord = [lat, lng];
			if (lat) {
				Axios.get(
					`${Setting.apiUrl}api/representative/nearest?lat=${lat}&lng=${lng}`
				).then((res) => {
					console.log(res.data);
					setNearest(res.data);
					SetData(cord, res.data);
				});
			} else {
				history.push("/");
			}
		}
	}

	render() {
		return (
			<div>
				<TopOfNav />
				<DrawerNav />
				<NavBar style={{ zIndex: "1000" }} />
				<div>
					<div id="mapsearch" />
				</div>
				<Footer />
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	latLang: selectLatlng,
	Nearest: selectNearest,
});
const mapDispatchToProps = (dispatch) => ({
	setNearest: (threeData) => dispatch(SetNearest(threeData)),
	setLatLang: (latlang) => dispatch(SetLatLng(latlang)),
});
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MapPage)
);
